import { Theme, Users } from '@just-in-types';
import * as React from 'react';
import styled from 'react-emotion';
import { firestore } from '../firebase';
import Button from './Button';
import LoaderButton from './LoaderButton';
import Modal from './Modal';
import Row from './Row';
import Text from './Text';

interface ICouponOwnProps {
  businessId: string;
  coupon: Users.Coupon;
  colors: Theme.Colors;
  userId: string;
  visible: boolean;
}

type CouponProps = ICouponOwnProps;

interface ICouponOwnState {
  redeeming: boolean;
  showModal: boolean;
}

type CouponState = ICouponOwnState;

interface ICouponBodyProps {
  visible: boolean;
}
const CouponBody = styled('div')`
  display: grid;
  grid-template-columns: 3fr 1fr;
  align-items: center;
  height: ${(props: ICouponBodyProps) => (props.visible ? 'auto' : 0)};
  visibility: ${(props: ICouponBodyProps) =>
    props.visible ? 'visible' : 'hidden'};
`;
const CouponText = styled(Text)`
  font-weight: bold;
  color: black;
  text-shadow: none;
  margin-left: 2rem;
`;
const CouponHR = styled('hr')`
  width: 80%;
  height: 2px;
`;

class Coupon extends React.Component<CouponProps, CouponState> {
  public initialState: CouponState = { redeeming: false, showModal: false };

  constructor(props: CouponProps) {
    super(props);

    this.state = this.initialState;
  }

  public toggleModal = () =>
    this.setState(({ showModal }) => ({ showModal: !showModal }));

  public redeemCoupon = async () => {
    const {
      coupon: { couponId },
      userId,
    } = this.props;
    this.setState({ redeeming: true });

    // TODO: Make nice messages for customers when errors happen
    await firestore
      .collection(`users/${userId}/coupons`)
      .doc(couponId)
      .update({
        redemption_date: new Date(),
        redemption_flag: true,
      });

    this.setState(this.initialState);
  };

  public render() {
    const { coupon, colors, visible } = this.props;
    const { redeeming, showModal } = this.state;
    const couponDate = (timestamp: Users.CouponDate) => {
      if (timestamp) {
        const date = 'toDate' in timestamp ? timestamp.toDate() : timestamp;
        const day = date.getDate();
        const month = date.getMonth() + 1;
        const year = date.getFullYear();

        return `${month}/${day}/${year}`;
      } else {
        return 'no expiration';
      }
    };
    const modalToggler = redeeming ? undefined : this.toggleModal;

    return (
      <React.Fragment>
        <CouponBody visible={visible}>
          <CouponText size="2rem">{coupon.coupon_name}</CouponText>
          <Button bg={colors.success} onClick={modalToggler}>
            Redeem
          </Button>
        </CouponBody>
        {visible && <CouponHR />}
        {showModal && (
          <Modal onToggleModal={modalToggler}>
            <Row>
              <CouponText size="2.5rem">{coupon.coupon_name}</CouponText>
            </Row>
            <Row>
              <CouponText>{coupon.coupon_description}</CouponText>
            </Row>
            <Row>
              <CouponText>
                Expires: {couponDate(coupon.expires_date)}
              </CouponText>
            </Row>
            <Row>
              <Button
                bg={colors.error}
                disabled={redeeming}
                onClick={modalToggler}>
                Cancel
              </Button>
              <LoaderButton
                bg={colors.success}
                loading={redeeming}
                onClick={this.redeemCoupon}>
                Redeem
              </LoaderButton>
            </Row>
          </Modal>
        )}
      </React.Fragment>
    );
  }
}

export default Coupon;



// WEBPACK FOOTER //
// ./src/components/Coupon.tsx